import dsBridge from 'dsbridge'

export interface NativeResult<T> {
  code: number
  message: string
  data: T
}

export interface NativeRequest {
  method: string
  data?: Record<string, any>
}

export function callNative<T = any>(
  request: NativeRequest
): Promise<NativeResult<T>> {
  return new Promise((resolve) => {
    dsBridge.call('jtH5CallNativeApi', request, (responseData: any) => {
      resolve(JSON.parse(responseData))
    })
  })
}

export const isAPP = navigator.userAgent.includes('isAPP')
export const FIRST_URL_KEY = 'FIRST_URL_KEY'
export const nativeBack = () => {
  console.log('原生返回')
}
